import { useContracts } from '../useContracts';

export const useCreateOrder = () => {
  const contracts = useContracts();
  const manager = contracts?.manager;
  if(!manager) return undefined;

  return manager.makeUsdtForPpe;
};
